import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/main.css";
import "./styles/index.scss";
import ReduxProvider from "./providers/ReduxProvider";
import { pdfjs } from "react-pdf";
import { PermissionStateProvider } from "./providers/PermissionProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.3.136/pdf.worker.min.mjs`;
root.render(
  <React.StrictMode>
    <ReduxProvider>
      <PermissionStateProvider>
        <App />
      </PermissionStateProvider>
    </ReduxProvider>
  </React.StrictMode>,
);
